import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-consignment-line-select',
  templateUrl: './consignment-line-select.component.html',
  styleUrls: ['./consignment-line-select.component.css']
})
export class ConsignmentLineSelectComponent implements OnInit {
    consignmentKeyno;

    public setting?: Setting;

    public itemsListConsignmentLines: Item[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.consignmentKeyno = this.stateService.getStateParams()['consignment_keyno'];
    }

    private async loadSetting() {
        if (!!this.consignmentKeyno) {
            this.setting = (await this.datatask.Post(1434, { consignment_keyno: this.consignmentKeyno }))[0];
        }
    }

    private async loadConsignmentLines() {
        if (!this.setting) return;

        return this.itemsListConsignmentLines = await this.datatask.Post(1435, { consignment_keyno: this.setting.consignment_keyno });
    }

    public async saveChanges() {
        if (!!this.setting && !!this.itemsListConsignmentLines) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1436, {
                    consignment_keyno: this.setting.consignment_keyno,
                    records: this.itemsListConsignmentLines
                }))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    toggleChosen(item: any): void {
        item = item?.item ? item.item : item;

        if (item.item_id === '0' || item.item_id === '-1') return;

        if (item.item_is_selected === '0') {
            item.item_is_selected = '1';
        } else if (item.item_is_selected === '1') {
            item.item_is_selected = '0';
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadConsignmentLines();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    webpage_heading: string;
    consignment_keyno: string;
}
